module.exports = __webpack_public_path__ + "img/icon_09.b16380c5.png";